const AboutPSAOA = () => {
  const roles = [
    "Maintenance of common areas",
    "Monitoring of Facility Management",
    "Financial management and statutory compliance",
    "Vendor coordination",
    "Safety, security, and emergency preparedness",
  ];

  return (
    <section id="psaoa" className="py-20 sm:py-28 bg-white">
      <div className="section-container">
        <h2 className="section-title">About PSAOA</h2>
        <p className="section-subtitle">
          Governance and community management
        </p>

        <div className="max-w-3xl">
          <p className="text-lg text-foreground leading-relaxed mb-8">
            The Purva Swanlake Apartment Owners' Association (PSAOA) is a duly constituted body that represents 
            the collective interests of all apartment owners. We are committed to maintaining the highest standards 
            of community living through professional management and transparent governance.
          </p>

          <h3 className="text-2xl font-bold text-foreground mb-6">Key Responsibilities</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {roles.map((role, index) => (
              <div key={index} className="flex items-start gap-3 bg-blue-50 p-4 rounded-lg border border-blue-100">
                <span className="snapshot-bullet mt-1" />
                <span className="text-foreground font-medium">{role}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutPSAOA;
